import { TaskType } from './taskTypesModel'
import JobRefreshParametersFields from './JobRefreshParametersFields'

type Props = {
  type: TaskType
}

const TaskParametersFields = ({ type }: Props) => {
  switch (type) {
    case 'job-refresh':
      return <JobRefreshParametersFields />
  }
}

export default TaskParametersFields
